import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/cn';

export interface Tab {
  label: string;
  to: string;
}

/** Underlined tabs. The active tab gets a 2px accent rule, matching the mockups. */
export function TabRow({ tabs, className }: { tabs: Tab[]; className?: string }) {
  return (
    <nav className={cn('flex items-center gap-6 border-b border-border', className)}>
      {tabs.map(tab => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end
          className={({ isActive }) =>
            cn(
              '-mb-px border-b-2 px-0.5 pb-3 text-[13px] transition-colors',
              isActive ? 'border-primary text-foreground' : 'border-transparent text-muted hover:text-foreground'
            )
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
